import type { ThemePreference } from "./theme";

export const THEME_STORAGE_KEY = "akaiva.themePreference";

/** A stored value that is not one of the three choices counts as `system`. */
export function parseThemePreference(value: string | null): ThemePreference {
  return value === "light" || value === "dark" || value === "system"
    ? value
    : "system";
}
